import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Row, Col, Label } from 'reactstrap';
import { formatVideoFromYoutube } from '@utils';

function VideoComponent({ values, handleBlur, handleChange }) {
  const [videoPreview, setVideoPreview] = useState(() => {
    return formatVideoFromYoutube(values.video || '');
  });

  return (
    <Row lg={12} className="mb-1">
      <Col lg={3}>
        <Label htmlFor="video" className="label-road-input">
          Link del video
        </Label>
        <Input
          type="text"
          name="video"
          id="video"
          placeholder="https://youtube.com/..."
          onChange={(e) => {
            setVideoPreview(formatVideoFromYoutube(e.target.value) || '');

            handleChange(e);
          }}
          onBlur={handleBlur}
          value={values.video}
          required
        />
      </Col>
      <Col lg={3}>
        {(videoPreview !== '' &&
          videoPreview.startsWith('https://youtube.com')) ||
        videoPreview.startsWith('https://www.youtube.com') ? (
          <iframe
            width="366"
            height="198"
            src={`${videoPreview}?controls=0`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <div
            style={{
              width: 366,
              height: 198,
              background: '#F7F7F7'
            }}
            className="position-relative"
          >
            <span
              className="position-absolute fw-bolder top-50 start-50 translate-middle"
              style={{
                color: '#6D6B7B',
                fontSize: 14
              }}
            >
              Preview
            </span>
          </div>
        )}
      </Col>
    </Row>
  );
}

VideoComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired
};

export default VideoComponent;
